export class loginModel {
    email: string;
    password: string;
    fireBaseToken : string;
  }
  